import { Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { LanguageProvider, Language } from './contexts/LanguageContext';
import MainContent from './components/MainContent';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import About from './components/About';
import Help from './components/Help';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import Contact from './components/Contact';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';

// 语言检测和重定向组件
function LanguageRedirect() {
  const location = useLocation();

  useEffect(() => {
    // 如果访问根路径，重定向到默认语言
    if (location.pathname === '/') {
      const savedLanguage = localStorage.getItem('language') as Language;
      const browserLanguage = navigator.language.startsWith('zh') ? 'zh' : 'en';
      const defaultLanguage = savedLanguage || browserLanguage;

      // 重定向到默认语言路径
      window.location.replace(`/${defaultLanguage}`);
    }
  }, [location]);

  return <Navigate to="/en" replace />;
}

// 语言验证包装器
function LanguageValidation({ children }: { children: React.ReactNode }) {
  const { lang } = useParams<{ lang: string }>();

  // 验证语言代码是否有效
  if (lang !== 'en' && lang !== 'zh') {
    return <Navigate to="/en" replace />;
  }

  return <>{children}</>;
}

// 语言路由包装器
function LanguageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <LanguageProvider>
      <LanguageValidation>
        {children}
      </LanguageValidation>
    </LanguageProvider>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* 根路径重定向 */}
        <Route path="/" element={<LanguageRedirect />} />

        {/* 语言路由 */}
        <Route path="/:lang/*" element={
          <LanguageWrapper>
            <Routes>
              <Route path="/" element={<MainContent />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/about" element={<About />} />
              <Route path="/help" element={<Help />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:postId" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </LanguageWrapper>
        } />

        {/* 兜底重定向到404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;